import axios from 'axios';
import { useEffect, useState } from 'react';
import { ProductModel} from '../models/product';
import { useParams } from 'react-router-dom';
import { User } from '../models/user';

interface ProductsPageProps {
    category?: string,
}

export const GetProductsByCategory = (loggedInUser:User | null, group2?:ProductsPageProps ) => {

    //group2 = useParams();
    const params = useParams<{ category?: string }>(); // Get params from the URL
    const category = group2?.category || params.category; // Prefer prop over URL param

    const [loading, setLoading] = useState<boolean>(true);
    const [products, setProducts] = useState<ProductModel[]>([]);

    useEffect(()=> {
        async function loadProducts() {
            if (loggedInUser) {
                try {
                    const response = await axios.post(
                        category ? "/api/shop/productsbycat/" + category : "/api/shop/allproducts",
                        {
                            "GROUP2": category
                        }
                    );
                    const products = await response.data;
                    setProducts(products);
                    setLoading(false);
                } catch (error) {
                    console.error(error);
                }
            }
        }
        loadProducts();
    },[category,loggedInUser]);
    
    return { products, loading };
};